import { render } from "./CrosswordArea.vue?vue&type=template&id=4ffda1a0&scoped=true"
import script from "./CrosswordArea.vue?vue&type=script&lang=js"
export * from "./CrosswordArea.vue?vue&type=script&lang=js"

import "./CrosswordArea.vue?vue&type=style&index=0&id=4ffda1a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffda1a0"]])

export default __exports__